export default "__VITE_ASSET__633d38d6__"